import { useLayoutEffect, useRef } from 'react';
import { services } from '../data';

const topServices = services.filter((service) =>
  ['bookkeeping', 'cleanup', 'setup'].includes(service.id)
);
const bottomServices = services.filter((service) =>
  ['training', 'payroll'].includes(service.id)
);

function ServiceCard({ service }) {
  const toneClass =
    service.id === 'bookkeeping'
      ? ' is-bookkeeping'
      : service.id === 'payroll'
        ? ' is-payroll'
        : '';

  return (
    <article className={`service-card${toneClass}`} data-reveal>
      <h3>{service.title}</h3>
      <p className="service-tagline">{service.tagline}</p>
      <ul className="rule-list">
        {service.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </article>
  );
}

export default function Services() {
  const topRef = useRef(null);
  const bottomRef = useRef(null);

  useLayoutEffect(() => {
    const top = topRef.current;
    const bottom = bottomRef.current;
    if (!top || !bottom) return undefined;

    if (typeof window.matchMedia !== 'function') return undefined;

    const mq = window.matchMedia('(min-width: 861px)');
    let frame = 0;

    const sync = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        top.style.height = '';
        bottom.style.height = '';
        if (!mq.matches) return;
        bottom.style.height = `${top.offsetHeight}px`;
      });
    };

    mq.addEventListener('change', sync);
    window.addEventListener('resize', sync);
    sync();

    return () => {
      cancelAnimationFrame(frame);
      mq.removeEventListener('change', sync);
      window.removeEventListener('resize', sync);
      top.style.height = '';
      bottom.style.height = '';
    };
  }, []);

  return (
    <section className="section services" id="services">
      <div className="container">
        <div className="section-head" data-reveal>
          <h2 className="display-2">
            What Rime <em>offers.</em>
          </h2>
          <p className="section-lede">
            Bookkeeping and payroll services built to keep the financial side of your business
            accurate, up-to-date, and organized.
          </p>
        </div>

        <div className="service-stack">
          <div className="service-grid service-grid-top" ref={topRef}>
            {topServices.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
          <div className="service-grid service-grid-bottom" ref={bottomRef}>
            <figure className="service-media" data-reveal>
              <img
                src="/images/quickbooks-training.jpg"
                alt="Hands typing on a laptop during a focused work session"
                loading="lazy"
                decoding="async"
              />
            </figure>
            {bottomServices.map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
